import React, { useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../state/store";
import { useSelectedCareRecipient } from "../../hooks/care_recipient/useSelectedCareRecipient";
import { Paths } from "../../../Paths";
import { openDialogAction } from "../../../state/usecase/disease_knowledge/actions";
import { DashBoardIcon } from "./icons/DashBoardIcon";
import { MedicalKnowledgeIcon } from "./icons/MedicalKnowledgeIcon";
import { FAQIcon } from "../common/icons/FAQIcon";
import { DiseaseKnowledgeDialog } from "../disease_knowledge/DiseaseKnowledgeDialog";
import classNames from "classnames";
import { getCareCommentListAction, resetCareCommentAction } from "../../../state/usecase/care_comment/actions";
import { HukidashiIcon } from "../common/icons/HukidashiIcon";
import { ConfigurationIcon } from "./icons/ConfigurationIcon";

export const SideMenuContent = React.memo(function SideMenuContent() {
    const navigate = useNavigate();

    const location = useLocation();

    const buttonClassNames = useMemo(() => ({
        dashBoard: classNames("button", { "selected": location.pathname.startsWith(Paths.dashBoard) }),
        config: classNames("button", { "selected": location.pathname.startsWith(`${Paths.careRecipient}${Paths.config}`) }),
        faq: classNames("button", { "selected": location.pathname.startsWith(`${Paths.faq}${Paths.list}`) }),
        careComment: classNames("button", { "selected": location.pathname.startsWith(Paths.careComment) }),
    }), [location.pathname]);

    const dispatch = useAppDispatch();

    const selectedCareRecipient = useSelectedCareRecipient();

    const disabled = selectedCareRecipient === null;

    const handleDashBoardClicked = useCallback(() => {
        navigate(`${Paths.dashBoard}/${selectedCareRecipient?.id.value}`);
    }, [navigate, selectedCareRecipient]);

    const handleMedicalKnowledgeClicked = useCallback(() => {
        dispatch(openDialogAction("list"));
    }, [dispatch]);

    const handleFAQClicked = useCallback(() => {
        navigate(`${Paths.faq}${Paths.list}`);
    }, [navigate]);

    const handleSettingsClicked = useCallback(() => {
        navigate(`/care_recipient${Paths.config}/${selectedCareRecipient?.id.value}`);
    }, []);

    useEffect(() => {
        if (selectedCareRecipient) {
            dispatch(
                getCareCommentListAction(selectedCareRecipient.id)
            );
        } else {
            dispatch(resetCareCommentAction());
        }
    }, [dispatch, selectedCareRecipient]);

    const handleCareCommentClicked = useCallback(() => {
        navigate(`${Paths.careComment}/${selectedCareRecipient?.id.value}`);
    }, [navigate, selectedCareRecipient]);


    return (
        <>
            <li className={"side_menu__row"}>
                <button className={buttonClassNames.dashBoard} disabled={disabled} onClick={handleDashBoardClicked}>
                    <DashBoardIcon />
                    <div className="text">
                        <div className={"title"}>生活リズム</div>
                    </div>
                </button>
            </li>
            <li className={"side_menu__row"}>
                <button className={buttonClassNames.config} disabled={disabled} onClick={handleSettingsClicked}>
                    <ConfigurationIcon />
                    <div className="text">
                        <div className={"title"}>設定</div>
                    </div>
                </button>
            </li>
            <li className={"side_menu__row"}>
                <button className={buttonClassNames.careComment} onClick={handleCareCommentClicked}>
                    <HukidashiIcon />
                    <div className="text">
                        <div className={"title"}>ケアコメント</div>
                    </div>
                </button>
            </li>
            <li className={"side_menu__row"}>
                <button className={"button"} onClick={handleMedicalKnowledgeClicked}>
                    <MedicalKnowledgeIcon />
                    <div className="text">
                        <div className={"title"}>医療知識</div>
                    </div>
                </button>
                <DiseaseKnowledgeDialog />
            </li>
            <li className={"side_menu__row"}>
                <button className={buttonClassNames.faq} onClick={handleFAQClicked}>
                    <FAQIcon />
                    <div className="text">
                        <div className={"title"}>よくあるご質問</div>
                    </div>
                </button>
            </li>
        </>
    );
});
